import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthService } from '../auth.service';
import { CommonService } from "../../shared/common/common.service";

@Injectable()
export class UnauthGuard {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate() {
    if (!this.authService.isAuthenticated) {
      return true;
    } else {
      this.authService.navigateToLandingPage();
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/guards/unauth-guard.service.ts